import Input from "@components/common/Input";
import { SetNewVoucherToken } from "@services/vesselService";
import { Modal } from "flowbite-react";
import { useState } from "react";
import { customModalTheme } from "styles/customTheme";

export const ModalTokenVoucher = ({
	isOpen,
	closeModal,
	token,
	fetchConfigurations,
	cPortal,
	setcPortal,
	handleCaptivePortal,
}) => {
	const [name, setname] = useState("");
	const [numTokens, setnumTokens] = useState("");

	const [quota, setquota] = useState("");

	const [loadingSubmit, setLoadingSubmit] = useState(false);
	const [errors, setErrors] = useState({
		cPortal: "",
		name: "",
		quota: "",
		numTokens: "",
	});

	const [errorMessage, setErrorMessage] = useState("");
	const [successMessage, setSuccessMessage] = useState("");

	const validateForm = () => {
		const newErrors = {};
		const trimmed = name.trim();

		if (!cPortal?.cp_name) {
			newErrors.cPortal = "Captive portal is required.";
		}

		if (!trimmed) {
			newErrors.name = "Token name is required.";
		} else if (trimmed.length < 3) {
			newErrors.name = "Token name must contain at least 3 characters.";
		}

		if (!numTokens) {
			newErrors.numTokens = "Number of tokens is required.";
		} else if (Number(numTokens) < 1 || Number(numTokens) > 50) {
			newErrors.numTokens = "Number of tokens must be between 1 and 50.";
		}

		if (!quota.trim()) {
			newErrors.quota = "Quota is required.";
		} else if (!Number.isInteger(Number(quota))) {
			newErrors.quota = "Quota must be a valid integer.";
		}

		setErrors(newErrors);

		return Object.keys(newErrors).length === 0;
	};
	const handleNameChange = (value) => {
		setname(value);
		setErrors((prev) => ({
			...prev,
			name: "",
		}));
	};

	const handleNumTokensChange = (value) => {
		// Allow only numbers from 1 to 50
		if (value === "" || (/^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 50)) {
			setnumTokens(value);

			setErrors((prev) => ({
				...prev,
				numTokens: "",
			}));
		}
	};

	const handlequotaChange = (value) => {
		setquota(value);
		setErrors((prev) => ({
			...prev,
			quota: "",
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!validateForm()) {
			return;
		}

		setLoadingSubmit(true);
		setErrorMessage("");
		setSuccessMessage("");

		const data = {
			token: name.trim(),
			nb_of_token: Number(numTokens),
			bandwidth_quota: quota.trim(),
		};

		try {
			const createdToken = await SetNewVoucherToken(cPortal?.id, token, data);

			const message = createdToken?.message || "Token Added successfully";

			await fetchConfigurations();

			setSuccessMessage(message);

			setTimeout(() => {
				closeModal();
			}, 1200);
		} catch (err) {
			const errorData = err?.response?.data || err?.data || err;

			const message =
				Object.values(errorData?.errors || {})?.[0]?.[0] ||
				errorData?.message ||
				err?.message ||
				"Something went wrong";

			setErrorMessage(message);
		} finally {
			setLoadingSubmit(false);
		}
	};

	return (
		<>
			<Modal show={isOpen} onClose={closeModal} size="4xl" theme={customModalTheme}>
				<Modal.Header className="border-[#272B49] border-b bg-[#0F1535] px-5 py-4">
					<div>
						<h2 className="font-semibold text-lg text-white">Add New Token</h2>
					</div>
				</Modal.Header>
				<Modal.Body className="max-h-[75vh] overflow-y-auto px-4 py-5 md:px-6">
					<div className="space-y-7">
						{/* FORM GRID */}
						<div className="grid grid-cols-1 gap-5 md:grid-cols-2">
							{/* Captive Portal */}
							<div className="col-span-2">
								<label className="mb-2 block font-medium text-gray-300 text-sm">
									Captive Portal <span className="text-blue-gray">*</span>
								</label>

								<Input
									id="captiveportal"
									placeholder="Captive Portal"
									value={cPortal?.cp_name || ""}
									onChange={handleCaptivePortal}
									onClear={() => setcPortal("")}
									isDisabled={true}
									className={`input-bg block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-xs placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500`}
									required
								/>

								{errors?.cPortal && <p className="mt-1 text-red-500 text-xs">{errors?.cPortal}</p>}
							</div>

							{/* Token Name */}
							<div>
								<label className="mb-2 block font-medium text-gray-300 text-sm">
									Token Name <span className="text-blue-gray">*</span>
								</label>

								<Input
									id="name"
									placeholder="Ex: voucher"
									value={name}
									onChange={handleNameChange}
									onClear={() => setname("")}
									className={`input-bg block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-xs placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${errors.quota ? "border-red-500" : ""}`}
									required
								/>

								{errors.name && <p className="mt-1 text-red-500 text-xs">{errors.name}</p>}
							</div>

							{/* Number Tokens */}
							<div>
								<label className="mb-2 block font-medium text-gray-300 text-sm">
									Number of Tokens <span className="text-blue-gray">*</span>
								</label>

								<Input
									id="number-tokens"
									placeholder="1 - 50"
									value={numTokens}
									onChange={handleNumTokensChange}
									type="number"
									onClear={() => setnumTokens("")}
									min="1"
									max="50"
									className={`input-bg block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-xs placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${errors.numTokens ? "border-red-500" : ""}`}
								/>

								<div className="mt-1 flex items-center justify-between">
									<p className="text-gray-500 text-xs">Allowed range: 1 → 50</p>

									<p className="text-gray-500 text-xs">{numTokens || 0}/50</p>
								</div>

								{errors.numTokens && (
									<p className="mt-1 text-red-500 text-xs">{errors.numTokens}</p>
								)}
							</div>

							{/* TOKEN PREVIEW */}
							<div
								className={`max-h-6 overflow-hidden transition-all duration-300 ease-in-out ${
									name && numTokens ? "translate-y-0 opacity-100" : "-translate-y-0 opacity-0"
								}`}
							>
								<div className="flex flex-wrap items-center gap-2 rounded-md bg-navbar-bg px-2">
									<p className="font-semibold text-gray-400 text-xs">
										The following token
										{Number(numTokens) > 1 ? "s" : ""} will be created:
									</p>

									<p className="break-all text-blue-gray text-xs">
										{Number(numTokens) === 1
											? `${name}_1`
											: Number(numTokens) === 2
												? `${name}_1, ${name}_2`
												: `${name}_1 ... ${name}_${numTokens}`}
									</p>
								</div>
							</div>
							{/* Quota */}
							<div className="col-span-2">
								<label className="block font-medium text-gray-300 text-sm">
									Quota (MB) <span className="text-blue-gray">*</span>
								</label>

								<Input
									id="quota"
									placeholder="Ex: 1024"
									value={quota}
									onChange={handlequotaChange}
									onClear={() => setquota("")}
									className={`input-bg block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-xs placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${errors.name ? "border-red-500" : ""}`}
									required
								/>

								{errors.quota && <p className="mt-1 text-red-500 text-xs">{errors.quota}</p>}
							</div>
						</div>

						{/* ALERTS */}
						<div
							className={`overflow-hidden text-center transition-all duration-300 ease-in-out ${
								errorMessage || successMessage
									? "max-h-20 translate-y-0 opacity-100"
									: "max-h-0 translate-y-2 opacity-0"
							}`}
						>
							<div
								className={`px-2 py-2 text-sm ${errorMessage ? "text-red-500" : "text-green-300"}`}
							>
								{errorMessage || successMessage}
							</div>
						</div>
					</div>
				</Modal.Body>

				<Modal.Footer className="flex items-center border-[#272B49] border-t border-solid p-4 md:p-5">
					<>
						<button
							type="button"
							onClick={handleSubmit}
							disabled={loadingSubmit}
							className="mr-2 rounded-lg bg-button-bg px-4 py-2 text-[14px] text-white hover:bg-button-hover disabled:opacity-50"
						>
							{loadingSubmit ? "Processing..." : "Confirm"}
						</button>
						<button
							type="button"
							className="rounded-lg border-gray-600 bg-gray-200 px-4 py-2 text-[14px] text-blue-gray hover:bg-white hover:text-dark-blue focus:z-10 focus:outline-none focus:ring-4 focus:ring-gray-200"
							onClick={closeModal}
						>
							No, cancel
						</button>
					</>
				</Modal.Footer>
			</Modal>
		</>
	);
};
